import { compact } from 'lodash-es';
import { ALLOWED_DISCOUNT_EXPIRATION_TYPE } from '~/types/api/drafts-search';
import { discountExpirationDateLabel } from './serviceDiscountExpirationDate';
const TIMED_EXPIRATION_TYPES = [
    'period',
    'date'
];
const isAllowedExpirationType = (value)=>ALLOWED_DISCOUNT_EXPIRATION_TYPE.includes(value);
const hasExactMembers = (values, expected)=>{
    const unique = new Set(values);
    return unique.size === expected.length && expected.every((value)=>unique.has(value));
};
const includedTypes = (type)=>{
    var _type_nin, _type_in;
    const excluded = (_type_nin = type.nin) !== null && _type_nin !== void 0 ? _type_nin : [];
    if (excluded.length > 0) return ALLOWED_DISCOUNT_EXPIRATION_TYPE.filter((value)=>!excluded.includes(value));
    return (_type_in = type.in) !== null && _type_in !== void 0 ? _type_in : [];
};
export const discountExpirationKind = (expiration)=>{
    const type = expiration === null || expiration === void 0 ? void 0 : expiration.type;
    if (type == null) return null;
    const included = includedTypes(type);
    if (hasExactMembers(included, TIMED_EXPIRATION_TYPES)) return 'has';
    if (included.length !== 1) return null;
    const only = included[0];
    return isAllowedExpirationType(only) ? only : null;
};
export const hasDiscountExpirationContent = (expiration)=>discountExpirationKind(expiration) != null || (expiration === null || expiration === void 0 ? void 0 : expiration.date) != null;
export const discountExpirationValueLabel = (kind, t)=>{
    switch(kind){
        case 'none':
            return t.servicesDiscountExpirationNoneLabel();
        case 'period':
            return t.servicesDiscountExpirationPeriodLabel();
        case 'date':
            return t.servicesDiscountExpirationDateLabel();
        case 'has':
            return t.servicesDiscountExpirationHasLabel();
    }
};
export const discountExpirationChipLabels = (kind, t)=>kind === 'has' ? {
        fieldLabel: t.servicesPriceIncreaseServiceHasLabel(),
        valueLabel: t.servicesDiscountExpirationLabel()
    } : {
        fieldLabel: t.servicesDiscountExpirationLabel(),
        valueLabel: discountExpirationValueLabel(kind, t)
    };
const isTimedKind = (kind)=>kind === 'period' || kind === 'date';
export const discountExpirationSummary = (kind, t)=>isTimedKind(kind) ? "".concat(t.servicesDiscountExpirationLabel(), " ").concat(discountExpirationValueLabel(kind, t)) : discountExpirationValueLabel(kind, t);
const dateImpliesKind = (kind)=>kind === 'has' || kind === 'date';
const discountExpirationDateSummary = (date, t)=>"".concat(t.servicesDiscountExpirationLabel(), " ").concat(discountExpirationDateLabel(date, t));
export const discountExpirationSegments = (expiration, t)=>{
    const kind = discountExpirationKind(expiration);
    const date = expiration === null || expiration === void 0 ? void 0 : expiration.date;
    const kindSegment = kind != null && (date == null || !dateImpliesKind(kind)) ? discountExpirationSummary(kind, t) : null;
    const dateSegment = date != null ? discountExpirationDateSummary(date, t) : null;
    return compact([
        kindSegment,
        dateSegment
    ]);
};
export const discountExpirationNoun = (expiration, t)=>{
    const kind = discountExpirationKind(expiration);
    if (kind === 'none') return null;
    const date = expiration === null || expiration === void 0 ? void 0 : expiration.date;
    if (date != null) return "".concat(t.servicesDiscountExpirationNoun(), " ").concat(discountExpirationDateLabel(date, t));
    if (kind == null) return null;
    if (kind === 'has') return t.servicesDiscountExpirationNoun();
    return "".concat(t.servicesDiscountExpirationNoun(), " ").concat(discountExpirationValueLabel(kind, t));
};
